import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LetterRequestCustomer_Cancel } from 'src/app/Interface/LetterRequestCustomer_Cancel';
import { Schedule_Interface } from 'src/app/Interface/Schedule_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { ScheduleService } from 'src/app/Service/Schedule/Schedule.service';

@Component({
  selector: 'app-ScheduleForm',
  templateUrl: './ScheduleForm.component.html',
  styleUrls: ['./ScheduleForm.component.scss']
})
export class ScheduleFormComponent implements OnInit {

  @Input() inner_expert_id:number=0
  @Input() inner_expert_title:string=""
  @Input() inner_persianDate: string = ""
  @Output() OnBack_Action = new EventEmitter<number>();

  Token:String=""

  constructor(
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
    private Schedule_Service: ScheduleService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_subject()
  }

  Dsc: string = ''
  Type_id: string = '0'
  page=0
  DataList_Selected_Schedules:Array<LetterRequestCustomer_Cancel>=[]
  InProccessing: boolean = false


  Submit() {

    if (!this.Dsc) {
      this.Alertify_Service.ErrorMessage("Enter the description.")
    }
    else {
      this.InProccessing=true

      var DataList_Selected_Schedules_id: Array<number> = []
      for (let item of this.DataList_Selected_Schedules)
      {
        DataList_Selected_Schedules_id.push(item.id)
      }

      this.Schedule_Service.Submit(this.Dsc,
        this.inner_persianDate,
        this.inner_expert_id,
        Number(this.Type_id),
        DataList_Selected_Schedules_id,
        this.Token).subscribe(
          data => {
            this.InProccessing = false

            if (data['id'] == 1) {
              this.Alertify_Service.SuccessMessage("Information saved successfully.")
              this.DataList_Selected_Schedules = []
              this.Dsc = ''
              this.Read_subject()
            }
            else {
              this.Alertify_Service.ErrorMessage("Leave has already been registered for this date.")
            }
          }, error => {
            localStorage.clear()
            location.reload();
          }
        )
    }
  }

  DataList_Subject:Array<Schedule_Interface>=[]
  Read_subject() {
    this.InProccessing = true
    this.Schedule_Service.GetRecord(this.Token, this.inner_expert_id, this.inner_persianDate).subscribe(
      data => {
        this.DataList_Subject = data
        this.InProccessing = false
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  Delete(item:Schedule_Interface) {
    this.InProccessing = true
    this.Schedule_Service.Delete(this.Token, item.id).subscribe(
      data => {
        this.Read_subject()
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
        this.InProccessing = false
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  ChangeStatus(item:Schedule_Interface) {
    this.InProccessing = true
    this.Schedule_Service.Status(this.Token, item.id).subscribe(
      data => {
        this.Read_subject()
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.InProccessing = false
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#region Search Hokem

  page_Schedules=0
  DataList_Schedules:Array<LetterRequestCustomer_Cancel>=[]
  Procssing_schedule:boolean=false
  Filter_Letter:string="0"
  ReadData_Schedules(){
    this.Procssing_schedule=true

    this.LetterRequestCustomer_Service.GetActiveMissionByLetter(this.Token,Number(this.Filter_Letter),2).subscribe(
      data=>{
        this.DataList_Schedules=data
        this.Procssing_schedule=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  select_hokem(item:LetterRequestCustomer_Cancel)
  {
    var IsInList: boolean = false
    for (let detail of this.DataList_Selected_Schedules)
    {
      if (item.id == detail.id)
      {
        IsInList = true
        break
      }
    }
    if (IsInList)
      this.Alertify_Service.ErrorMessage("The decree is already in the list.")
    else {
      this.Alertify_Service.SuccessMessage("The decree was added.")
      this.DataList_Selected_Schedules.push(item)
      this.modalRef_Hokem.hide()
    }
  }

  delete_hokem(item:number)
  {
    this.Alertify_Service.SuccessMessage("The decree was removed.")
    this.DataList_Selected_Schedules.splice(item,1)
  }

  modalRef_Hokem:any
  openModal(template: TemplateRef<any>) {

    this.modalRef_Hokem = this.modalService.show(template);
  }
  //#endregion


  On_Back() {
    this.OnBack_Action.emit(-1);
  }

}
